module Meevo.Plugins.Register {

    export class RegisterNotesService  {
        constructor(
            public $q: ng.IQService,
            public $translate: angular.translate.ITranslateService,
            public dataService: Meevo.Components.BaseClasses.IDataService,
            public modalService: Meevo.Components.Modal.IModalService,
            public meevoNoteService: Meevo.Plugins.Note.NoteService
        ) {
        }

        private visitNoteModels: VisitNoteServiceModel[] = [];
        private saleNoteExists: boolean = false;
        public saleNoteTextRefund: string = "";
        private aggregatedNotes: Meevo.Plugins.Note.INote[] = [];
        private aggregatedNotesExclude: Meevo.Plugins.Note.INote[] = [];

        resetSaleNotes() {
            this.saleNoteExists = false;
            this.saleNoteTextRefund = "";
        }

        resetAggregatedNotes() {
            this.aggregatedNotes = [];
            this.aggregatedNotesExclude = [];
        }

        resetVisitNotes() {
            if (this.visitNoteModels.length > 0) {
                this.visitNoteModels = [];
            }
        }

        doesSaleNoteExist() {
            return this.saleNoteExists;
        }

        isRefundReasonValid(): boolean {
            if (!this.saleNoteTextRefund) {
                return false;
            }

            var result = this.saleNoteTextRefund.match(/[A-Za-z]/g);

            return result != null && result.length >= 1;
        }

        displayVisitNoteServicePrompt() : ng.IPromise<any> {
            if (this.visitNoteModels.length > 0) {
                return this.showClientVisitNoteModal(this.visitNoteModels).then(() => {
                    this.visitNoteModels = [];
                });
            }
        }

        addVisitNoteModel(visitNoteModel) {
            this.visitNoteModels.push(visitNoteModel);
        }

        private showClientVisitNoteModal(visitNoteModels: VisitNoteServiceModel[]): ng.IPromise<any> {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/register/modals/visitNoteService.template.html",
                controller: "meevo.plugins.register.VisitNoteServiceController",
                controllerAs: "vm",
                bindToController: true,
                escapeToClose: true,
                clickOutsideToClose: false,
                locals: {
                    incomingModels: visitNoteModels
                }
            }

            return this.modalService.showCustom(options);
        }

        //NOTE: Discount and Transaction Notes are treated by UI as same Note with different look features, though saved as separate notes with types. Other Sale Notes are taken care as per other Types
        showAddSaleNoteModal(registerContext: Meevo.Plugins.Register.RegisterContext, saleNoteDisplayInDiscountChecked: boolean) {
            if (!registerContext.saleNoteCanOpen()) {
                return;
            }

            let note = this.getSaleNote(registerContext.sale, Model.SaleNoteTypeEnum.Discount);
            if (!note) {
                note = this.getSaleNote(registerContext.sale, Model.SaleNoteTypeEnum.Transaction);
            }

            let isChecked = (saleNoteDisplayInDiscountChecked ? true : (note ? note.noteType == Model.SaleNoteTypeEnum.Discount : false));

            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/register/modals/noteAdd.template.html",
                controller: "meevo.plugins.register.ModalController",
                controllerAs: "vm",
                bindToController: true,
                locals: {
                    registerContext: registerContext,
                    note: (note ? note.noteText : ""),
                    isChecked: isChecked,
                    modalType: RegisterModalTypeEnum.SaleNote
                }
            };

            return this.modalService.showCustom(options);
        }

        private getSaleNote(sale: Model.Sale, noteType: Model.SaleNoteTypeEnum) {
            if (sale && sale.saleNotes && sale.saleNotes.length > 0) {
                if (noteType == null) {
                    return sale.saleNotes[0];
                } else {
                    return _(sale.saleNotes).findWhere({ noteType: noteType });
                }
            }

            return null;
        }

        private getSaleNoteText(registerContext: Meevo.Plugins.Register.RegisterContext, noteType: Model.SaleNoteTypeEnum) {
            let note = this.getSaleNote(registerContext.sale, noteType);
            if (note) {
                return note.noteText;
            }

            return "";
        }

        saveSaleNote(registerContext: Meevo.Plugins.Register.RegisterContext, noteText: string, isChecked: boolean) {
            let noteType = (isChecked ? Model.SaleNoteTypeEnum.Discount : Model.SaleNoteTypeEnum.Transaction);
            this.deleteSaleNoteByType(registerContext, Model.SaleNoteTypeEnum.Transaction);
            this.deleteSaleNoteByType(registerContext, Model.SaleNoteTypeEnum.Discount);
            this.setSaleNote(registerContext.sale, noteText, noteType);
            this.saleNoteExists = (noteText && noteText.length > 0);
        }

        setSaleNote(sale: Model.Sale, noteText: string, noteType: Model.SaleNoteTypeEnum) {
            let note = this.getSaleNote(sale, noteType);
            if (note) {
                if (noteText.length === 0) {
                    this.deleteSaleNote(sale, note);
                } else {
                    note.noteText = noteText;
                }
            } else {
                if (noteText.length > 0) {
                    sale.saleNotes.push({ noteText: noteText, noteType: noteType, noteTypeDescription: Model.SaleNoteTypeEnum[noteType] });
                }
            }
        }

        private deleteSaleNoteByType(registerContext: Meevo.Plugins.Register.RegisterContext, noteType: Model.SaleNoteTypeEnum) {
            let note = this.getSaleNote(registerContext.sale, noteType);
            if (note) {
                this.deleteSaleNote(registerContext.sale, note);
            }
        }

        private deleteSaleNote(sale: Model.Sale, note) {
            if (!note) {
                return;
            }

            sale.saleNotes.splice(_.indexOf(sale.saleNotes, note), 1);
        }

        saleNotesMerge(sale: Model.Sale, additionalSaleNotes: Model.saleNote[]) {
            if (!additionalSaleNotes || additionalSaleNotes.length == 0) {
                return;
            }

            for (const additionalSaleNote of additionalSaleNotes) {
                switch (additionalSaleNote.noteType) {
                    case Model.SaleNoteTypeEnum.Discount:
                    case Model.SaleNoteTypeEnum.Transaction:
                        const noteT = this.getSaleNote(sale, Model.SaleNoteTypeEnum.Transaction);
                        const noteD = this.getSaleNote(sale, Model.SaleNoteTypeEnum.Discount);

                        const noteType = ((noteD != null) || (additionalSaleNote.noteType === Model.SaleNoteTypeEnum.Discount))
                            ? Model.SaleNoteTypeEnum.Discount
                            : Model.SaleNoteTypeEnum.Transaction;

                        const noteText = (noteT ? noteT.noteText + " " : "") + (noteD ? noteD.noteText + " " : "") + additionalSaleNote.noteText;

                        this.deleteSaleNote(sale, noteT);
                        this.deleteSaleNote(sale, noteD);

                        this.setSaleNote(sale, noteText, noteType);

                        this.saleNoteExists = (noteText && noteText.length > 0);
                        break;

                    default:
                        const note = this.getSaleNote(sale, additionalSaleNote.noteType);
                        if (note) {
                            note.noteText += " " + additionalSaleNote.noteText;
                        } else {
                            sale.saleNotes.push(additionalSaleNote);
                        }
                        break;
                }
            }
        }

        showServiceNote(noteService: Meevo.Plugins.Note.INoteService) {
            return this.meevoNoteService.loadAggregatedNotes(null, null, [ noteService ], Model.ClientNoteViewTimeEnum.CheckOut).then((response) => {
                this.meevoNoteService.usageTrackingLog(Meevo.Model.NounEnum.RegisterPage, Meevo.Model.VerbEnum.ServiceNotesViewed);

                const parsedNotes = _(this.meevoNoteService.parseAggregatedNotes(response.data, noteService)).sortBy("isTenantOrOwnedServiceNote");
                for (let parsedNote of parsedNotes) {
                    parsedNote.isNewNote = false;
                }
                this.addAggregatedNotes(parsedNotes, null, noteService.entityId);
                return this.meevoNoteService.showNotes(parsedNotes);
            });
        }

        private addAggregatedNotes(aggregatedNotes: Meevo.Plugins.Note.INote[], clientId: string, entityId: string) {
            for (var aggregatedNote of aggregatedNotes) {
                const isExistingNote = _(this.aggregatedNotes).any((note) => (
                    (
                        note.entityId === entityId ||
                        note.clientGlobalId === clientId ||
                        (note.clientGlobalIds && note.clientGlobalIds.indexOf(clientId) !== -1)
                    ) &&
                    note.noteText === aggregatedNote.noteText
                ));

                if (isExistingNote) {
                    continue;
                }

                this.aggregatedNotes.push(aggregatedNote);
            }
        }

        private getAggregatedNotes(
            noteAppointments: Meevo.Plugins.Note.INoteAppointment[],
            noteClients: Meevo.Plugins.Note.INoteClient[],
            noteServices: Meevo.Plugins.Note.INoteService[]
        ): ng.IPromise<any> {
            //console.log('registerNotesService:getAggregatedNotes', arguments);

            return this.meevoNoteService.loadAggregatedNotes(null, noteClients, noteServices, Model.ClientNoteViewTimeEnum.CheckOut).then((response) => {
                //console.log('-> registerNotesService:loadAggregatedNotes response', response);

                for (const noteAppointment of noteAppointments) {
                    const parsedNotes = this.meevoNoteService.parseAggregatedNotes(response.data, noteAppointment);
                    this.addAggregatedNotes(parsedNotes, null, noteAppointment.entityId);
                }

                for (const noteClient of noteClients) {
                    const parsedNotes = this.meevoNoteService.parseAggregatedNotes(response.data, noteClient);
                    this.addAggregatedNotes(parsedNotes, noteClient.clientId, null);
                }

                for (const noteService of noteServices) {
                    const parsedNotes = this.meevoNoteService.parseAggregatedNotes(response.data, noteService);
                    this.addAggregatedNotes(parsedNotes, null, noteService.entityId);
                }
            });
        }

        getAppointmentNotesFromAppointmentServices(sale: Model.Sale, services: any[]): Model.NoteSourceItem[] {
            const notes: Model.NoteSourceItem[] = [];

            for (const service of services) {
                let note = _(notes).findWhere({ entityId: service.appointmentId });

                if ((service.noteType === Model.AppointNoteTypeEnum.Register || service.noteType === Model.AppointNoteTypeEnum.CheckinRegister)
                    && service.noteText.trim() != ""
                    && !note
                    && !_(sale.appointNotes).findWhere({ appointmentId: service.appointmentId })) {
                    note = {
                        noteId: service.appointmentId,
                        entityId: service.appointmentId,
                        entityName: null,
                        note: service.noteText,
                        isRegisterType: true,
                        isAppointmentType: false,
                        clients: [],
                    };
                    notes.push(note);
                }

                if (!note) {
                    continue;
                }

                const noteClientExists = _(note.clients).any(client =>
                    client.clientId == service.clientId &&
                    client.clientType == service.clientType);

                if (noteClientExists) {
                    continue;
                }

                note.clients.push({
                    clientId: service.clientId,
                    clientType: service.clientType,
                    displayName: service.clientDisplayName,
                });
            }

            return notes;
        }

        getAppointmentNotes(notes: Model.NoteSourceItem[]) {
            for (const note of notes) {
                for (let index = 0; index < note.clients.length; index++) {
                    const client = note.clients[index];

                    const existingNote = _(this.aggregatedNotes).find(aggregatedNote =>
                        aggregatedNote.clientGlobalId == client.clientId &&
                        aggregatedNote.clientType == client.clientType &&
                        aggregatedNote.isAppointmentNote &&
                        aggregatedNote.appointmentId == note.entityId
                    );

                    if (existingNote) {
                        continue;
                    }

                    this.aggregatedNotes.push({
                        id: note.entityId.toString(),
                        entityId: note.entityId.toString(),
                        clientGlobalId: client.clientId,
                        clientType: client.clientType,
                        displayName: client.displayName,
                        noteText: note.note,
                        isAppointmentType: note.isAppointmentType,
                        isRegisterType: note.isRegisterType,
                        isAppointmentNote: true,
                        appointmentId: note.entityId.toString(),
                        isNewNote: true,
                        isGroupedNote: false,
                        originalNote: note,
                    });
                }
            }
        }

        removeAggregatedNote(clientId: string) {
            const notes = _(this.aggregatedNotes).where({ clientGlobalId: clientId });

            for (const note of notes) {
                if (note.isRegisterType) {
                    this.aggregatedNotesExclude.push(note);
                };

                this.aggregatedNotes.splice(_.indexOf(this.aggregatedNotes, note), 1);
            }
        }

        showAggregatedNotes(registerContext: Meevo.Plugins.Register.RegisterContext, clients: any[] = undefined, sale: Model.Sale = undefined): angular.IPromise<boolean> {
            sale = sale || registerContext.sale;

            const requestClients = clients || registerContext.allUniqueClients;
            const serviceSaleLines = _(sale.saleLines).filter(saleLine => registerContext.isServiceType(saleLine));

            if (!requestClients && !serviceSaleLines) {
                return this.$q.resolve(true);
            }

            //when Client is added, and not processed into allUniqueClients[], call is made with Client selected

            const noteAppointments: Meevo.Plugins.Note.INoteAppointment[] = _.chain(requestClients)
                .filter(client => !!client.appointmentId)
                .map(client => ({
                    entityId: client.appointmentId,
                    appointmentId: client.appointmentId,
                }))
                .uniq()
                .value();

            const noteClients: Meevo.Plugins.Note.INoteClient[] = _.chain(requestClients)
                .filter(client => client.client)
                .map(client => ({
                    entityId: client.client.id,
                    clientId: client.client.id,
                    clientType: client.clientType || Meevo.Model.ClientTypeEnum.Client,
                    clientDisplayName: client.client.displayName
                }))
                .uniq()
                .value();

            const noteServices: Meevo.Plugins.Note.INoteService[] = _.chain(serviceSaleLines)
                .filter(saleLine => !!saleLine.item)
                .map(saleLine => ({
                    entityId: saleLine.item.id,
                    serviceId: saleLine.item.id,
                 }))
                .uniq()
                .value();

            return this.getAggregatedNotes(noteAppointments, noteClients, noteServices).then(() => {
                const newNotes = _.chain(this.aggregatedNotes).uniq().filter(note => note.isNewNote).value();

                const notes = this.buildGroupedNotes(newNotes);

                if (_(notes).any(note => note.isAppointmentNote)) {
                    this.meevoNoteService.usageTrackingLog(Meevo.Model.NounEnum.RegisterPage, Meevo.Model.VerbEnum.AppointmentNotesViewed);
                }

                if (_(notes).any(note => note.isClientNote)) {
                    this.meevoNoteService.usageTrackingLog(Meevo.Model.NounEnum.RegisterPage, Meevo.Model.VerbEnum.ClientNotesViewed);
                }

                if (_(notes).any(note => note.isMembershipNote)) {
                    this.meevoNoteService.usageTrackingLog(Meevo.Model.NounEnum.RegisterPage, Meevo.Model.VerbEnum.MembershipNotesViewed);
                }

                if (_(notes).any(note => note.isServiceNote)) {
                    this.meevoNoteService.usageTrackingLog(Meevo.Model.NounEnum.RegisterPage, Meevo.Model.VerbEnum.ServiceNotesViewed);
                }

                return this.meevoNoteService.showNotes(notes);
            });
        }

        private buildGroupedNotes(newNotes: Meevo.Plugins.Note.INote[]) {
            //console.log('buildGroupedNotes', arguments);
            const groupedNotes: Meevo.Plugins.Note.INote[] = [];

            const groupNotes = (notes: Meevo.Plugins.Note.INote[]) => {
                let clientNames: string[] = [];
                let clientIds: string[] = [];

                for (const note of notes) {
                    const isNoteExcluded = _(this.aggregatedNotesExclude).any(noteExclude => noteExclude.clientGlobalId === note.clientGlobalId);

                    if (!isNoteExcluded) {
                        if (note.displayName) {
                            switch (note.displayName) {
                                case "LABEL_ANONYMOUS_MALE":
                                case "LABEL_ANONYMOUS_FEMALE":
                                case "LABEL_ANONYMOUS_OTHER":
                                    note.displayName = this.$translate.instant(note.displayName);
                                    break;
                            }

                            clientNames.push(note.displayName);
                            clientIds.push(note.clientGlobalId);
                        }
                        note.isNewNote = false;
                    }
                }

                const note = notes[0];

                note.clientNames = clientNames;

                if (clientNames.length > 1) {
                    note.displayName = clientNames.join('; ');
                    note.clientGlobalId = undefined;
                    note.clientGlobalIds = clientIds;
                    note.isGroupedNote = true;
                }

                const groupedNote = { ...note };
                groupedNotes.push(groupedNote);

                //console.log('buildGroupedNotes:groupNotes', 'note', note, 'groupedNote', clonedNote);
            }

            // Appointment Notes (clients grouped by appointment id)
            let apointmentNotes = _.chain(newNotes).where({ isAppointmentNote: true }).sortBy("displayName").groupBy("appointmentId").value();
            _(apointmentNotes).each((notes) => {
                //console.log('buildGroupedNotes:appointmentNotes', notes);
                groupNotes(notes);
            });

            // Service Notes (clients grouped by service id + CO ownership)
            let serviceNotes = _.chain(newNotes).where({ isServiceNote: true }).sortBy(function (note) { return note.serviceId + '#' + note.isTenantOrOwnedServiceNote })
                .groupBy(function (note) { return note.serviceId + '#' + note.isTenantOrOwnedServiceNote }).value();
            _(serviceNotes).each((notes) => {
                groupNotes(notes);
            });


            // Membership Notes (clients grouped by membership id)
            let membershipNotes = _.chain(newNotes).where({ isMembershipNote: true }).sortBy("displayName").groupBy("membershipId").value();
            _(membershipNotes).each((notes) => {
                groupNotes(notes);
            });

            // Client Notes
            let clientNotes = _.chain(newNotes).where({ isClientNote: true }).sortBy("displayName").value();
            for (const note of clientNotes) {
                note.isNewNote = false;
                note.clientNames = [ note.displayName ];
                const clonedNote = { ...note };
                groupedNotes.push(clonedNote);
                //console.log('buildGroupedNotes:clientNotes', 'note', note, 'groupedNote', clonedNote);
            }

            return groupedNotes;
        }

        static factory(): Function {
            let svc = (
                $q,
                $translate,
                dataService,
                modalService,
                noteService
            ) => new RegisterNotesService(
                $q,
                $translate,
                dataService,
                modalService,
                noteService
            );

            svc.$inject = [
                "$q",
                "$translate",
                "meevo.components.common.DataService",
                "meevo.components.modal.ModalService",
                'meevo.plugins.note.NoteService',
            ];

            return svc;
        }
    }

    angular.module("meevo.plugins.register")
        .factory("meevo.plugins.register.RegisterNotesService", RegisterNotesService.factory());
}